import type { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { isServiceOrAdvisoryDomain } from "web_myplann/Portfolio/Helpers/isServiceOrAdvisoryDomain";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";
import { useContactAdvisor } from "web_myplann/Shared/Hooks/useContactAdvisor";

type PortfolioAdvisorRequestTarget = {
	kind: PortfolioItemKind;
	domain?: ClientPortfolioDomainEnum;
};

type PortfolioAdvisorRequestInput = {
	target: PortfolioAdvisorRequestTarget;
	name: string;
	contractNumber?: string | null;
};

const resolveNoun = (target: PortfolioAdvisorRequestTarget) => {
	if (target.kind === PortfolioItemKind.Property) {
		return Resources.Portfolio.Lock.Nouns.property;
	}

	return isServiceOrAdvisoryDomain(target.domain)
		? Resources.Portfolio.Lock.Nouns.service
		: Resources.Portfolio.Lock.Nouns.contract;
};

export const usePortfolioAdvisorRequest = ({
	target,
	name,
	contractNumber,
}: PortfolioAdvisorRequestInput) => {
	const { t } = useResource();
	const { openChat } = useContactAdvisor();

	const contractRef = contractNumber
		? t(Resources.Portfolio.Lock.contractRef, { number: contractNumber })
		: "";

	const requestEdit = () =>
		openChat(
			t(Resources.Portfolio.Lock.editRequestMessage, {
				noun: t(resolveNoun(target)),
				name,
				contractRef,
			}),
		);

	const requestFillValue = () =>
		openChat(
			t(Resources.Portfolio.Lock.fillValueRequestMessage, {
				name,
				contractRef,
			}),
		);

	const requestUpdateValue = () =>
		openChat(
			t(Resources.Portfolio.Lock.updateValueRequestMessage, {
				name,
				contractRef,
			}),
		);

	return { requestEdit, requestFillValue, requestUpdateValue };
};
